<template>
        <div :class="appType">
            <div class="content">
                <div class="background-image" :style="{'background-image': `url(${background})`}">
                    <a :href="pageUrl" target="_blank">
                        <img class="sp-logo mt-md-4" :src="require(`../../assets/images/${systemConst.LOGO_NAME}`)" alt="logo" title="logo">
                    </a>
                </div>
                <div class="background-text"><span v-html="backgroundText"></span></div>

                <div class="container p-0">
                    <div class="form-container col-lg-4 col-md-6 col-sm-12 mt-md-4 mr-md-4 mr-lg-2 p-0">
                      <keep-alive include="NestedPages">
                        <router-view />
                      </keep-alive>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
</template>

<script>
import Footer from '../organisms/Footer'
import systemConst from '@SYSTEM_CONSTANTS'

export default {
    name: 'MainTemplate',
    inject: ['$validator'],
    components: { Footer },
    data () {
        return {
            appType: process.env.VUE_APP_SYSTEM,
            backgroundText: this.$store.state.configData.backgroundText,
            pageUrl: process.env.VUE_APP_PAGE_URL,
            systemConst
        }
    },
    computed: {
        background () {
            return document.body.clientWidth > 768 ? this.$store.state.configData.backgroundImage : this.$store.state.configData.backgroundImageMobile
        },
    }
}
</script>
